// import styles from '../../assets/stylesheets/Screen.module.css';
// import Inputfield from './Input';
import Lottie from 'react-lottie-player'
import waiting_animation from "../../assets/animations/waiting_animation.json";

export default function FormLoader(){
	return (
	    <>
	    	<Lottie loop animationData={waiting_animation} play style={{ width: 350, height: 350 }}/>
	    </>  
  	);
}